// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"163":"docs","323":"oxc-me","557":"oxc-home"}[chunkId] + "." + {"163":"48dd4358","323":"3788bda5","557":"7285a524"}[chunkId] + ".css";
};